import React from 'react';
import { Route, Routes } from 'react-router-dom';
import StoreViewLandingPage from './pages/StoreViewLandingPage';
import StoreViewOrderDetailsPage from './pages/StoreViewOrderDetailsPage';
import BulkTrackingUpdatePage from './pages/BulkTrackingUpdatePage';
import ScanDeliveryPage from './pages/ScanDeliveryPage';
import BulkFinishServicePage from './pages/BulkFinishServicePage';


interface StoreViewProps {
  storeId: string;
  externalIdentity: string;
  associateId: string;
  associateEmail: string;
  associateName: string;
  profileId?: string;
}

export const StoreViewRoutes: React.FC<StoreViewProps> = ({ storeId, externalIdentity, associateId, associateEmail, associateName, profileId }) => (
  <Routes>
    <Route path="/" element={<StoreViewLandingPage storeId={storeId} externalIdentity={externalIdentity} associateId={associateId} associateEmail={associateEmail} associateName={associateName} profileId={profileId} />} />
    <Route
      path="/order-details"
      element={(
        <StoreViewOrderDetailsPage
          externalIdentity={externalIdentity}
          associateId={associateId}
          associateEmail={associateEmail}
          storeId={storeId}
          associateName={associateName}
        />
      )}
    />
    <Route
      path="/bulk-tracking"
      element={(
        <BulkTrackingUpdatePage
          externalIdentity={externalIdentity}
          storeId={storeId}
          associateId={associateId}
          associateEmail={associateEmail}
          associateName={associateName}
        />
      )}
    />
    <Route path="/scan-delivery" element={<ScanDeliveryPage externalIdentity={externalIdentity} associateId={associateId} associateEmail={associateEmail} associateName={associateName} storeId={storeId} />} />
    <Route path="/bulk-finish-service" element={<BulkFinishServicePage externalIdentity={externalIdentity} storeId={storeId} associateId={associateId} associateEmail={associateEmail} associateName={associateName}  profileId={profileId}/>} />
  </Routes>
);
